import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import App from "./App";
import { persistor, store } from "./redux/store";
import * as serviceWorker from "./serviceWorker";
import './assets/css/responsive.css'

ReactDOM.render(
  <Provider store={store} persistor={persistor}>
    <App />
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
